import { WalkInPaymentMethod } from "@/models/club";
export type DirectMethod = "card" | "cash" | "transfer" | "other";
export const directMethodValue: Record<DirectMethod, WalkInPaymentMethod> = {
  card: WalkInPaymentMethod.Value1, cash: WalkInPaymentMethod.Value2,
  transfer: WalkInPaymentMethod.Value3, other: WalkInPaymentMethod.Value4,
};
export const walkInPaymentMethodLabel = (method?: WalkInPaymentMethod | null) => {
  switch (method) {
    case WalkInPaymentMethod.Value1: return "کارت بانکی";
    case WalkInPaymentMethod.Value2: return "نقدی";
    case WalkInPaymentMethod.Value3: return "کارت‌به‌کارت";
    case WalkInPaymentMethod.Value4: return "سایر";
    default: return "ثبت نشده";
  }
};
